import { render, staticRenderFns } from "./UploadIncidentsDashboard.vue?vue&type=template&id=2aa1aaea"
import script from "./UploadIncidentsDashboard.vue?vue&type=script&lang=ts"
export * from "./UploadIncidentsDashboard.vue?vue&type=script&lang=ts"
import style0 from "./UploadIncidentsDashboard.vue?vue&type=style&index=0&id=2aa1aaea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports